import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Mousewheel, Navigation, Scrollbar } from "swiper";
import { ICategoryOption, IOption } from "../../../types/customizer";
import { useEffect, useState } from "react";
import clsx from "clsx";
import ArrowLeft from '../../../../assets/images/left-arrow.png';
import ArrowRight from '../../../../assets/images/right-arrow.png';
import './kaySizeFilter.scss';

type IKaySizeFilterProps = {
  options: IOption[];
  size: number;
  onChange: (value: number) => void;
  isSizeChanged: boolean;
  setIsSizeChanged: (value: boolean) => void;
}

const KaySizeFilter = ({ options, size, onChange, isSizeChanged, setIsSizeChanged }: IKaySizeFilterProps) => {
  const [swiper, setSwiper] = useState<any>(null);
  const [activeIndex, setActiveIndex] = useState(() => {
    const index = options.findIndex(item => item.selected);
    return index;
  });

  useEffect(() => {
    const index = options.findIndex(item => item.selected);
    setActiveIndex(index);
  }, [options]);

  useEffect(() => {
    swiper?.slideToLoop(activeIndex);
  }, [activeIndex, swiper, options.length]);

  const handleSizeChange = (index: number) => () => {
    if (index !== null && index !== undefined && index !== activeIndex) {
      setActiveIndex(index);
      const option = options[index];
      onChange(parseFloat(option.sku));
    }
    if(index === activeIndex) {
      setIsSizeChanged(true);
    }
  };

  return (
    <div className="kay-size-wrapper tw-overflow-y-auto tw-overflow-x-hidden tw-pb-2">
      <button type="button" className="kay-size-nav kay-size-nav-prev">
        <img src={ArrowLeft} alt="arrow-left" height={13} />
      </button>
      <Swiper
          onSwiper={setSwiper}
          slidesPerView="auto"
          slidesPerGroup={6}
          spaceBetween={8}
          navigation={{
            prevEl: '.kay-size-nav-prev',
            nextEl: '.kay-size-nav-next'
          }}
          modules={[Mousewheel, FreeMode, Scrollbar, Navigation]}
          className="tw-w-[calc(100%-100px)]"
      >
        {options.map((option: IOption | ICategoryOption, index: number) =>
          <SwiperSlide key={index} className={clsx('kay-size-slide tw-cursor-pointer', { 'active-slide': index === activeIndex && isSizeChanged })} onClick={handleSizeChange(index)}>
            {option.name}
          </SwiperSlide>)
        }
      </Swiper>
      <button type="button" className="kay-size-nav kay-size-nav-next">
        <img src={ArrowRight} alt="arrow-right" height={13} />
      </button>
    </div>
  );
};

export default KaySizeFilter;